/**
 * Footer Scripts
 */
document.addEventListener('DOMContentLoaded', function () {
  // Zaraz Consent Link
  const consentLink = document.getElementById('bfwt-manage-consent');
  if (consentLink) {
    consentLink.addEventListener('click', function (event) {
      event.preventDefault();
      if (typeof window.bfwt_trackEvent === 'function') {
        window.bfwt_trackEvent('consent_manager_open', {
          source: 'footer',
          event_category: 'settings',
        });
      }
      if (window.zaraz && window.zaraz.consent) {
        zaraz.consent.modal = true;
      } else {
        console.warn('Zaraz Consent API is not available.');
      }
    });
  }

  // Note: the footer eco-mode checkbox (#footerDarkModeToggle) is wired
  // by dark-mode.js, not here — eco mode === dark mode in this theme.
});
